import { useEffect } from "react";
import { toast } from "sonner";

import { hasNewAppVersion } from "@/lib/app-update";
import { isStandalonePwa } from "@/lib/pwa";

// Kiểm tra định kỳ khi app đang mở (PWA để mở cả ngày vẫn biết có bản mới).
const CHECK_INTERVAL_MS = 10 * 60 * 1000;
const TOAST_ID = "app-update-available";

/**
 * Báo "Có bản mới" khi server đã deploy bản khác bản đang chạy — CHỈ trong PWA đã
 * cài (mở từ icon). Tab trình duyệt thường không cần: mở lại / F5 là có bản mới.
 *
 * KHÔNG tự tải lại: người dùng hay chuyển sang app ngân hàng để thanh toán rồi quay
 * về — reload đúng lúc đó làm mất màn hình QR / trạng thái đang làm. Để họ tự bấm.
 */
export function AppUpdatePrompt() {
  useEffect(() => {
    if (!isStandalonePwa()) return;
    let isNotified = false;

    const check = async () => {
      if (isNotified || document.visibilityState !== "visible") return;
      if (!(await hasNewAppVersion())) return;
      isNotified = true;
      toast("Có bản mới", {
        id: TOAST_ID,
        description: "Bói Đê vừa được cập nhật. Tải lại để dùng bản mới nhất.",
        duration: Infinity,
        action: { label: "Cập nhật", onClick: () => window.location.reload() },
      });
    };

    // Mở lại PWA từ nền (iOS giữ app chạy nền rất lâu) → kiểm tra ngay.
    const onVisibilityChange = () => void check();
    document.addEventListener("visibilitychange", onVisibilityChange);
    const timer = window.setInterval(() => void check(), CHECK_INTERVAL_MS);
    void check();

    return () => {
      document.removeEventListener("visibilitychange", onVisibilityChange);
      window.clearInterval(timer);
    };
  }, []);

  return null;
}
